// Comunicado NAVMED: 1ª AIC de 2026/2, aplicada em 06/08/2026.
export const TP_REFERENCE={period:8,mean:50.25,standardDeviation:7.61,referenceAnswers:65.47,maxGrade:5,totalQuestions:100};
export function estimateTpGrade(correctAnswers){
 if(!Number.isInteger(correctAnswers)||correctAnswers<0||correctAnswers>TP_REFERENCE.totalQuestions)return null;
 return Math.min(TP_REFERENCE.maxGrade,correctAnswers/TP_REFERENCE.referenceAnswers*TP_REFERENCE.maxGrade);
}
